import { makeStyles } from "@mui/styles";
import heroSlide1Bg from "../assets/img/hero-slide1-bg.webp";
import heroSlide2Bg from "../assets/img/hero-slide2-bg.webp";

const styles = (theme) => {
  return {
    toolBar: {
      height: "10vh",
      display: "flex",
      justifyContent: "space-between",
      padding: "20px",
      backgroundColor: "white",
    },
    logo: {
      color: "blue",
      cursor: "pointer",
    },
    link: {
      color: "#000",
    },
    menuIcon: {
      color: "#000",
    },
    formContainer: {
      flexGrow: 1,
      padding: "10px",
      maxWidth: "700px",
      margin: "30px auto",
      [theme.breakpoints.between("xs", "sm")]: {
        width: "100%",
      },
    },
    form: {
      marginTop: "30px",
    },
    formHeading: {
      textAlign: "center",
    },
    mainHeroBox: {
      minHeight: "600px",
    },

    landingContainer: {
      backgroundColor: "#fff",
      width: "100%",
      overflow: "hidden",
    },
    heroBox: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "130px",
    },
    spacings: {
      maxWidth: "1440px",
      margin: "0 auto",
      paddingLeft: "20px",
      paddingRight: "20px",
      "@media (min-width: 768px)": {
        paddingLeft: "30px",
        paddingRight: "30px",
      },
      "@media (min-width: 1024px)": {
        paddingLeft: "90px",
        paddingRight: "90px",
      },
      "@media (min-width: 1536px)": {
        paddingLeft: "120px",
        paddingRight: "120px",
      },
    },
    heroContainer: {
      position: "relative",
      display: "flex",
      flexDirection: "column",
      justifyContent: "start",
      alignItems: "start",
      height: "100%",
      color: "white",
      paddingTop: "140px",
      paddingBottom: "80px",
      fontFamily: "Roboto",
      "@media (min-width: 1024px)": {
        flexDirection: "row",
        paddingTop: "100px",
        paddingBottom: "60px",
        alignItems: "center",
        height: "85vh",
      },
    },
    heroSlide1: {
      backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 40%), url(${heroSlide1Bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    heroSlide2: {
      backgroundImage: `linear-gradient(90deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.5) 40%), url(${heroSlide2Bg})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
    h2HeroContainer: {
      fontSize: "clamp(32px, 7vw, 60px)",
      maxWidth: "90vw",
      fontWeight: "800",
      lineHeight: "1.1",
      paddingBottom: "0px",
      marginBottom: "0px",
      textAlign: "center",
      "@media (min-width: 1024px)": {
        fontSize: "60px",
        maxWidth: "568px",
        fontWeight: "800",
        lineHeight: "66px",
        paddingBottom: "0px",
        marginBottom: "0px",
        textAlign: "start",
      },
    },
    p1HeroContainer: {
      paddingTop: "6px",
      marginTop: "0px",
      fontSize: "clamp(14px, 3vw, 20px)",
      maxWidth: "100%",
      fontWeight: "700",
      lineHeight: "22px",
      "@media (min-width: 1024px)": {
        fontSize: "20px",
        maxWidth: "568px",
        paddingTop: "15px",
      },
    },
    p2HeroContainer: {
      paddingTop: "0px",
      marginTop: "0px",
      fontSize: "clamp(16px, 4vw, 20px)",
      maxWidth: "90vw",
      fontWeight: "400",
      lineHeight: "1.3",
      textAlign: "center",
      "@media (min-width: 1024px)": {
        paddingTop: "5px",
        fontSize: "18px",
        maxWidth: "568px",
        lineHeight: "28.8px",
        textAlign: "start",
      },
    },
    heroButton: {
      marginTop: "10px",
      border: "2px solid #79B357",
      background:
        "linear-gradient(90deg, #59A959 0%, #79B357 65.87%, #AFCD56 95.67%)",
      borderRadius: "50px",
      padding: "0px 25px",
      color: "#FAFAFA",
      fontSize: "clamp(16px, 4vw, 18px)",
      fontWeight: "500",
      width: "auto",
      height: "48px",
      cursor: "pointer",
      letterSpacing: "0.5px",
      "@media (min-width: 1024px)": {
        fontSize: "18px",
        width: "auto",
        height: "56px",
        padding: "0px 25px",
        marginTop: "7px",
      },
    },
    lastHeroContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      marginLeft: "0px",
      marginTop: "55px",
      "@media (min-width: 1024px)": {
        marginLeft: "80px",
        marginTop: "30px",
      },
    },
    lastHeroContainerImage: {
      height: "525px",
      width: "300px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      transition: "background-image 1s ease-in-out",
      "@media (min-width: 1024px)": {
        height: "700px",
        width: "400px",
      },
    },
    firstHeroContainer: {
      width: "100%",
      "@media (min-width: 1024px)": {
        width: "50%",
      },
      "@media (min-width: 1536px)": {
        width: "50%",
      },
    },
    firstHeroContainerOne: {
      width: "100%",
      display: "flex",
      gap: "5px",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      "@media (min-width: 1024px)": {
        width: "50%",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        flexDirection: "column",
      },
      "@media (min-width: 1536px)": {
        width: "50%",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        flexDirection: "column",
      },
    },
    firstDownloadContainerTwo: {
      width: "100%",
      paddingLeft: "0px",
      display: "flex",
      color: "#212121",
      alignItems: "center",
      justifyContent: "start",
      flexDirection: "column",
      "@media (min-width: 1024px)": {
        width: "50%",
        paddingLeft: "20%",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        flexDirection: "column",
      },
      "@media (min-width: 1536px)": {
        width: "50%",
        display: "flex",
        alignItems: "start",
        justifyContent: "start",
        flexDirection: "column",
      },
    },
    imageBox: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginTop: "100px",
    },
    gridContainer: {
      display: "flex",
      alignItems: "center",
      maxWidth: "1300px",
      padding: "50px",
    },
    aboutUsContainer: {
      width: "100%",
      display: "flex",
      minHeight: "400px",
      alignItems: "center",
      justifyContent: "center",
      margin: "5px 0px 50px 0px",
    },
    aboutUsSubtitle: {
      opacity: "0.7",
      paddingBottom: "30px",
      fontSize: "18px",
    },
    titleMain: {
      marginTop: "120px",
      paddingBottom: "10px",
      color: "#FFFFFF",
      fontFamily: "Roboto",
      fontWeight: 800,
      maxWidth: "100%",
    },
    title: {
      paddingBottom: "15px",
    },
    subtitleMain: {
      opacity: "0.7",
      paddingBottom: "30px",
      color: "#fff",
    },
    subtitle: {
      opacity: "0.4",
      paddingBottom: "30px",
    },
    largeImage: {
      width: "100%",
    },
    sectionGridContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
    sectionGridItem: {
      padding: "50px",
      width: "200px",
      borderRadius: "10px",
      margin: "10px !important",
    },
    sectionGridItem1: {
      width: "550px",
      borderRadius: "10px",
      padding: "10px",
    },
    inputField: {
      marginBottom: "20px !important",
    },
    textArea: {
      width: "100%",
      marginBottom: "20px",
      fontSize: "16px",
      padding: "10px",
    },
    footerContainer: {
      display: "flex",
      alignItems: "center",
      miHeight: "10vh",
      padding: "20px",
      justifyContent: "center",
      backgroundColor: "#f2f0f1",
      flexDirection: "column",
    },
    footerText: {
      paddingBottom: "10px",
    },
    footerDate: {
      opacity: "0.4",
    },
    testimonialCard: {
      backgroundColor: "#fff",
      padding: "10px",
      minHeight: "200px",
      display: "flex",
      alignItems: "center",
    },
    testimonialStatement: {
      paddingBottom: "25px",
    },
    avatar: {
      marginRight: "10px",
    },
    testimonialPosition: {
      fontSize: "14px",
      opacity: "0.6",
    },
    bookaRideSection: {
      paddingBlock: "80px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexDirection: "row",
      color: "#212121",
      fontFamily: "Roboto",

      "@media (max-width: 1024px)": {
        flexDirection: "column",
        paddingBlock: "32px",
      },
    },
    reverseOnMobile: {
      "@media (max-width: 1024px)": {
        flexDirection: "column-reverse",
      },
    },
    h2SectionContainer: {
      fontSize: "clamp(28px, 5vw, 40px)",
      fontWeight: "700",
      lineHeight: "1.2",
      marginTop: "0",
      paddingBottom: "0px",
      marginBottom: "0px",
      "@media (min-width: 1024px)": {
        fontSize: "40px",
        maxWidth: "25ch",
        fontWeight: "700",
        lineHeight: "46px",
        paddingBottom: "0px",
        marginBottom: "0px",
      },
    },
    p1SectionContainer: {
      fontSize: "clamp(16px, 4.3vw, 18px)",
      maxWidth: "90vw",
      fontWeight: "400",
      lineHeight: "1.38",
      paddingBottom: "0px",
      marginBottom: "0px",
      "@media (min-width: 1024px)": {
        fontSize: "18px",
        maxWidth: "486px",
        lineHeight: "28.8px",
        paddingBottom: "0px",
        marginBottom: "0px",
      },
    },
    buttonSectionContainer: {
      marginTop: "20px",
    },
    sectionImageContainer: {
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "center",
      width: "40%",
      borderRadius: "20px",
      overflow: "hidden",
      background:
        "linear-gradient(90deg, #59A959 0%, #79B357 48.08%, #AFCD56 100%)",

      "@media (max-width: 1024px)": {
        width: "100%",
        marginBottom: "60px",
      },
    },

    sectionContainerImage: {
      width: "100%",
      height: "100%",
      objectFit: "cover",
    },

    bookRideTextContainer: {
      width: "50%",
      paddingLeft: "20px",
      paddingRight: "20px",

      "@media (max-width: 1024px)": { width: "100%", textAlign: "center" },
    },

    downloadContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      color: "white",
      paddingTop: "20px",
      paddingBottom: "10%",
      fontFamily: "Roboto",

      "@media (min-width: 1024px)": {
        flexDirection: "row",
        paddingTop: "30px",
        justifyContent: "space-between",
      },
      "@media (min-width: 1536px)": {
        paddingTop: "0px",
        flexDirection: "row",
        justifyContent: "space-between",
      },
      "@media (min-height: 801px)": {
        paddingBottom: "10%",
      },
    },

    h2DownloadContainer: {
      fontSize: "clamp(28px, 6.9vw, 40px)",
      maxWidth: "90vw",
      fontWeight: "700",
      lineHeight: "1.2",
      textAlign: "center",
      paddingBottom: "0px",
      marginBottom: "0px",
      marginTop: "0px",
      paddingTop: "0px",
      "@media (min-width: 1024px)": {
        textAlign: "start",
        fontSize: "40px",
        maxWidth: "472px",
        fontWeight: "800",
        lineHeight: "44px",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginBottom: "0px",
      },
    },
    h2CoreValuesContainer: {
      fontSize: "clamp(28px, 6.3vw, 43px)",
      maxWidth: "90vw",

      fontWeight: "700",
      lineHeight: "35.2px",
      textAlign: "center",
      paddingBottom: "0px",
      marginBottom: "0px",
      marginTop: "0px",
      paddingTop: "0px",
      "@media (min-width: 1024px)": {
        textAlign: "start",
        fontSize: "43px",
        maxWidth: "100%",
        fontWeight: "800",
        lineHeight: "44px",
        paddingTop: "0px",
        paddingBottom: "0px",
        marginBottom: "0px",
      },
    },
    downloadButton: {
      marginTop: "10px",
      border: "2px solid #4F913C",
      backgroundColor: "#4F913C",
      borderRadius: "50px",
      padding: "0px 25px",
      color: "#FAFAFA",
      fontSize: "clamp(16px, 4.3vw, 18px)",
      maxWidth: "90vw",
      fontWeight: "500",
      width: "auto",
      height: "48px",
      cursor: "pointer",
      letterSpacing: "0.5px",
      "@media (min-width: 1024px)": {
        fontSize: "18px",
        width: "auto",
        height: "56px",
        padding: "16px",
        marginTop: "20px",
      },
    },
    lastDownloadImage: {
      height: "525px",
      width: "300px",
      paddingTop: "0px",
      backgroundSize: "cover",
      backgroundPosition: "center",
      transition: "background-image 1s ease-in-out",
      "@media (min-width: 1024px)": {
        height: "700px",
        width: "400px",
        marginTop: "0px",
      },
    },

    firstDownloadContainerThree: {
      display: "flex",
      flexDirection: "column",
      "@media (min-width: 1024px)": {
        width: "50%",
      },
      "@media (min-width: 1536px)": {
        width: "50%",
      },
    },

    firstDownloadContainer: {
      display: "flex",
      flexDirection: "column",
      paddingLeft: "0px",
      "@media (min-width: 1024px)": {
        width: "50%",
        marginLeft: "90px",
        marginTop: "130px",
      },
      "@media (min-width: 1536px)": {
        width: "50%",
        marginLeft: "90px",
      },
    },
    p2DownloadContainer: {
      paddingTop: "10px",
      marginTop: "0px",
      fontSize: "clamp(16px, 4vw, 18px)",
      maxWidth: "90vw",
      fontWeight: "400",
      lineHeight: "1.3",
      textAlign: "center",
      "@media (min-width: 1024px)": {
        paddingTop: "15px",
        fontSize: "18px",
        maxWidth: "472px",
        lineHeight: "28.8px",
        textAlign: "start",
      },
    },

    coreValuesContainerDiv: {
      backgroundColor: "white",
      fontFamily: "Roboto",
    },

    coreValuesContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "60px 0px",
      gap: "15px",
      "@media (min-width: 1024px)": {
        gap: "40px",
        padding: "90px 0px",
      },
    },

    valuesContainer: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "0px",
      alignItems: "center",
      width: "100%",
      paddingTop: "5%",
      "@media (min-width: 1024px)": {
        gap: "80px",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        paddingTop: "10px",
      },
    },
    valueContainer: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      flex: "0 0 50%",
      boxSizing: "border-box",
      paddingBottom: "15px",
      justifyContent: "center",
      "@media (min-width: 1024px)": {
        justifyContent: "center",
        flex: "0 0 0%",
        paddingBottom: "0px",
      },
    },
    valuePText: {
      color: "#0F172A",
      fontFamily: "Roboto",
      fontWeight: "700",
      fontSize: "clamp(16px, 4vw, 24px)",
      maxWidth: "90vw",
      lineHeight: "26.4px",
      letterSpacing: "0%",
      "@media (min-width: 1024px)": {
        fontSize: "24px",
      },
    },

    valueImage: {
      width: "16%",
      height: "20px,",
      "@media (min-width: 1024px)": {
        width: "50px",
        height: "50px",
      },
    },

    allavailabilityContainer: {
      backgroundColor: "#FCFFF5",
    },

    availabilityContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      alignItems: "center",
      gap: "50px",
      padding: "10px 0px",
      fontFamily: "Roboto",

      "@media (max-width: 992px)": {
        "& > div": {
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
        },
      },

      "@media (min-width: 1024px)": {
        flexDirection: "row",
        padding: "50px 0px",
      },
    },
    h2AvailabilityContainer: {
      fontSize: "clamp(28px, 6.5vw, 56px)",
      maxWidth: "90vw",
      fontWeight: "800",
      lineHeight: "36px",
      paddingBottom: "0px",
      marginBottom: "0px",
      color: "#0F172A",
      "@media (min-width: 1024px)": {
        fontSize: "56px",
        fontWeight: "800",
        lineHeight: "66px",
        paddingBottom: "10px",
        marginBottom: "0px",
      },
    },
    pAvailabilityContainer: {
      fontSize: "clamp(16px, 8vw, 20px)",
      maxWidth: "90vw",
      lineHeight: "1.3",
      marginTop: "15px",
      color: "#0F172A",
      fontWeight: "400",
      "@media (min-width: 1024px)": {
        paddingTop: "15px",
        fontSize: "20px",
        maxWidth: "684px",
        lineHeight: "28.8px",
        marginTop: "0px",
      },
    },
    downloadavailabilityBtn: {
      display: "flex",
      gap: "15px",
      cursor: "pointer",
    },

    downloadavailabilityImg: {
      height: "500px",
      width: "100%",
      "@media (min-width: 1024px)": {
        height: "575px",
        width: "100%",
      },
    },

    // Fast Rides Section
    fastRidesSubtitle: {
      color: "#5EAA59",
      fontFamily: "Roboto",
      fontWeight: "500",
      fontSize: "clamp(16px, 4vw, 20px)",
      textTransform: "uppercase",
    },

    fastRidesList: {
      listStyle: "none",
      paddingLeft: "0px",

      "& li": {
        display: "flex",
        alignItems: "center",
        gap: "16px",
      },
    },

    primaryLinearBg: {
      background:
        "linear-gradient(90deg, #59A959 0%, #79B357 48.08%, #AFCD56 100%)",
    },
    primaryBtn: {
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      height: "auto !important",
      border: "none",
      background:
        "linear-gradient(90deg, #59A959 0%, #79B357 48.08%, #AFCD56 100%)",
      textDecoration: "none",
      color: "white",
      padding: "16px 24px !important",
      borderRadius: "30px",
      fontSize: "clamp(16px, 4vw, 18px)",

      "@media (max-width: 1024px)": {
        fontSize: "16px",
      },
    },
  };
};

const useStyles = makeStyles(styles);
export default useStyles;
